<template>
    <div>
        <!-- Modal Procedimentos -->
        <div class="modal fade" id="selecaoProcedimentosModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Procedimentos Habilitados</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <div v-if="!procedimentos || !procedimentos.length">
                            <az-empty-state msg="Nenhum procedimento identificado" />
                        </div>

                        <div v-else>

                            <p class="alert alert-danger" v-if="item && item.medico_especialidade && !item.medico_especialidade.length">
                                Nenhuma especialidade cadastrada para o prestador.
                            </p>

                            <div class="d-flex flex-column mb-3">
                                <az-input
                                    type="button-group"
                                    :optionsList="[{ id: 'lista', search: 'Ativos' }, { id: 'edicao', search: 'Todos' }]"
                                    v-model="viewProc" />
                            </div>

                            <az-input
                                type="select"
                                icon="fa fa-filter"
                                placeholder="Todas as especialidades..."
                                :optionsList="lista_proc_especialidades"
                                optionsMode="json"
                                optionsData="id_especialidade"
                                v-model="filtroproc.id_especialidade" />

                            <az-input
                                type="select"
                                icon="fa fa-filter"
                                placeholder="Todas as classificações..."
                                :optionsList="lista_proc_classes"
                                optionsMode="json"
                                optionsData="id_classe_procedimento"
                                v-model="filtroproc.id_classe_procedimento" />

                            <az-input
                                icon="fa fa-search"
                                placeholder="Pesquisar..."
                                v-model="filtroproc.search">
                                <template v-slot:buttonposb>
                                    <div class="input-group-append">
                                        <div class="input-group-text">{{ selecionados.length }}</div>
                                    </div>
                                </template>
                            </az-input>

                            <table class="table table-sm border-0 table-responsive" v-if="lista_classes && lista_classes.length">
                                <tr>
                                    <td class="text-nowrap">
                                        <a href="#" @click.prevent="filtrar(classe)" v-for="(classe, icx) in lista_classes" :key="icx">
                                            <span class="badge badge-success mr-1" >
                                                {{ classe }}
                                            </span>
                                        </a>
                                    </td>
                                </tr>
                            </table>

                            <div v-if="viewProc == 'edicao'">

                                <div v-if="procedimentos_todos.length">

                                    <button type="button" class="btn btn-outline-primary btn-sm mt-2 mb-1"
                                        @click="marcar_procedimentos ()">
                                        Todos
                                    </button>

                                    <template v-for="(proc, ip) in procedimentos_todos">
                                        <div v-if="valid_filtro_proc(proc)" :key="ip">
                                            <az-input
                                                type="checkbox-group"
                                                :label="proc.search + ' - ' + proc.especialidade.search"
                                                v-model="proc.medico_procedimento_unidades.fl_ativo"
                                                @input="proc.medico_procedimento_unidades.fl_ativo ? '' : ( marcarTodosProc = false )" />
                                        </div>
                                    </template>

                                </div>

                                <div v-else>
                                    <az-empty-state msg="Nenhum procedimento disponível" icon="fa fa-play" />
                                </div>

                            </div>

                            <div v-else>

                                <ul class="list-group" v-if="selecionados.length">
                                    <template v-for="(proc, ip) in selecionados">
                                        <li class="list-group-item"  :key="ip" v-if="valid_filtro_proc(proc)">
                                            <a href="#" class="card-link" @click.prevent="abrirProcedimento(proc)">
                                                {{ proc.search }}
                                            </a>
                                        </li>
                                    </template>
                                </ul>

                                <div v-else>
                                    <az-empty-state msg="Nenhum procedimento habilitado" icon="fa fa-play" />
                                </div>

                            </div>

                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="viewProc == 'edicao'" @click="atualizar_procedimentos()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            procedimentos_todos: null,
            procedimentos: null,
            filtroproc: {
                id_especialidade: "",
                id_classe_procedimento: "", 
                search: "",
            }, 
            viewProc: 'lista', 
        }
    },

    components: { 
        AzEmptyState, 
        AzInput,
        AzSubmit, 
    },

    props: ['item'], 

    computed: { 
        selecionados: function () { 
            if ( !this.procedimentos_todos ) { 
                return [];
            }

            return this.procedimentos_todos.filter(item => item.medico_procedimento_unidades.fl_ativo)
        },

        lista_proc_especialidades: function () {
            if ( !this.procedimentos_todos ) { 
                return [];
            }

            return _.sortBy(
                _.uniqBy(
                    this.procedimentos_todos.map(proc => proc.especialidade),
                    'id_especialidade'
                ),
                'search'
            );
        },

        lista_proc_classes: function () {
            if ( !this.procedimentos_todos ) { 
                return [];
            }

            return _.sortBy(
                _.uniqBy(
                    this.procedimentos_todos.map(proc => proc.classe_procedimento),
                    'id_classe_procedimento'
                ),
                'search'
            );
        },

        lista_classes: function () { 
            if ( !this.procedimentos_todos ) { 
                return [];
            }

            return _.uniq(
                this.procedimentos_todos.filter(item => item.js_classes)
                    .flatMap(item => item.js_classes)
                    .sort()
            );
        },
    },

    methods: { 
        valid_filtro_proc (proc) { 
            return this.valid_regex(proc) 
                && ( !this.filtroproc.id_especialidade || proc.id_especialidade == this.filtroproc.id_especialidade )
                && ( !this.filtroproc.id_classe_procedimento || proc.id_classe_procedimento == this.filtroproc.id_classe_procedimento );
        },

        marcar_procedimentos () {
            let lista = this.procedimentos_todos.filter(proc => this.valid_filtro_proc(proc));

            let marcar = lista.find(proc => !proc.medico_procedimento_unidades.fl_ativo);

            lista.forEach(element => {
                element.medico_procedimento_unidades.fl_ativo = ( marcar ? true : false );
            });
        },

        filtrar (texto) { 
            if ( this.filtroproc.search == '"' + texto + '"' ) { 
                this.filtroproc.search = "";
            } else { 
                this.filtroproc.search = '"' + texto + '"';
            }
        },

        valid_regex (item) {
            if ( !this.filtroproc.search )
                return true;

            let reg = this.$util.getregex(this.filtroproc.search);
            return reg.test(item.search) || ( item.js_classes && reg.test(JSON.stringify(item.js_classes)) );
        },

        atualizar_procedimentos () {
            this.$util.atualizar (this, {
                service: 'procedimentos',
                func: 'vincular_medico',
                dados: {
                    ...this.procedimentos_todos,
                },
                modal: 'selecaoProcedimentosModal',
            });
        },

        abrirProcedimentos () {
            this.viewProc = 'lista';

            this.$store.commit('loading', true);

            this.procedimentos_todos = null;
            this.procedimentos = null;
            this.filtroproc.id_especialidade = "";
            this.filtroproc.id_classe_procedimento = "";
            this.filtroproc.search = "";

            $('#selecaoProcedimentosModal').modal('show');

            let query = { q: [
                {
                    name: 'medico_unidades.index',
                    id: 'procedimentos',
                    parms: {
                        cadastro_agenda: true,
                        where: {
                            id_medico: this.item.id_pessoa,
                        }
                    }
                },
                {
                    name: 'procedimentos.index',
                    id: 'procedimentos_todos',
                    parms: {
                        id_medico: this.item.id_pessoa,
                        lista_cadastro: true,
                        prestadores: true,
                        ativos: true,
                        tags: true, 
                    }
                }
            ]};

            this.axios.post('/aql', query)
                .then(res => {
                    if ( res.data.procedimentos_todos.status == 200 ) {
                        this.procedimentos_todos = res.data.procedimentos_todos.data.map(item => {
                            if ( !item.medico_procedimento_unidades ) {
                                item.medico_procedimento_unidades = {
                                    id_medico_procedimento_unidade: null,
                                    id_medico_unidade: this.item.medico_unidade.id_medico_unidade,
                                    id_procedimento: item.id_procedimento,
                                    fl_ativo: false,
                                    in_tempo_atendimento: 30,
                                };
                            }
                            return item;
                        });
                    }

                    if ( res.data.procedimentos.status == 200 ) {
                        this.procedimentos = res.data.procedimentos.data.sort ((a, b) => {
                            return a.procedimento.search > b.procedimento.search ? 1 : -1;
                        });
                    }
                })
                .finally(() => {
                    this.$store.commit('loading', false);
                });
        },

        abrirProcedimento (proc) {
            this.$util.abrirProcedimento(proc);
        }

    }
}
</script>
